import { useMutation } from '@tanstack/react-query';
import type { MessagePinReq } from '../models/message-pin-dto';
import type { PinnedMessage } from '../models/message-pinned';
import { pinMessage } from '../utils/message-marker';
import { updatePinnedMessagesCache } from './use-message-pinned';

/**
 * Custom hook for pinning messages using React Query's useMutation.
 * @param conversationId - The ID of the conversation, can be null.
 * @param messageId - The ID of the message to pin, can be null.
 * @returns An object containing the mutation function and its state (e.g., isLoading, error).
 */
export const useMessagePin = (conversationId: Nullable<string>, messageId: Nullable<string>) => {
  return useMutation({
    mutationFn: (pinData: MessagePinReq) => pinMessage(conversationId!, messageId!, pinData),
    onSuccess: (data: PinnedMessage) => {
      updatePinnedMessagesCache(conversationId!, data);
    }
  });
};
